module.exports = __webpack_public_path__ + "img/thumb-griffin2.fc360722.png";